// extracted by mini-css-extract-plugin
export default {"control":"language_control__MqAhy","dropdown":"language_dropdown__qcVw1","item":"language_item__X8V4+","flag":"language_flag__EVapl"};